import { Button, Col, Container, Row, Spinner } from 'react-bootstrap'
import axios from "axios";
import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom'
import TableComponent from '../../../Table/Table';
import toast from 'react-hot-toast';

export default function Group() {
    const [searchParams] = useSearchParams();

    const AffiliateID = searchParams.get('id');

    const [loading, setLoading] = useState(true);
    const [mloading, setMLoading] = useState(false);
    const [commissiongroups, setCommissionGroups] = useState([]);
    const [affiliategroups, setAffiliateGroups] = useState([]);
    const [commission, setCommission] = useState([]);
    const [data, setData] = useState([]);
    const [page, setPage] = useState(1);
    const [websites, setWebsites] = useState([]);
    const [promocodes, setPromocodes] = useState([]);
    const [website, setWebsite] = useState("");
    const [promocode, setPromocode] = useState("");
    const [playerId, setPlayerId] = useState("");

    const nav = useNavigate();
    const columns = React.useMemo(
        () => [
            {
                Header: 'PlayerId',
                accessor: 'Id',
            },
            {
                Header: 'Username',
                accessor: 'Username',
            },
            {
                Header: "Actions",
                accessor: "Actions",
                Cell: (props) => {
                    return (
                        <><a className='player-table-link' onClick={() => RemovePlayer(props.row.original.Id)}>Remove</a></>
                    )
                }
            }
        ],
        []
    );

    const RemovePlayer = async (id) => {
        setLoading(true);

        const response = await axios.post(window.__CFG.API + "affiliates/RemoveAffiliatePlayer/" + id, {}, {
            headers: {
                "Authorization": "Beaer " + localStorage.getItem("raff-token")
            }
        })

        setLoading(false);

        if (response.data.Error == null) {
            GetPlayers(1);
        }
    }

    const GetPlayers = async (m_page) => {
        setLoading(true);

        const response = await axios.get(window.__CFG.API + "affiliates/ListAffiliatePlayers/" + AffiliateID + "&page=" + m_page, {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("raff-token")
            }
        })

        setLoading(false);

        if (response.data.Error == null) {
            setData(response.data.Result)
        }
    }

    useEffect(() => {
        GetPlayers(page);
    }, [page]);

    const MovePlayer = async () => {
        setMLoading(true);
        const response = await axios.post(window.__CFG.API + "affiliates/MoveAffiliatePlayer/" + AffiliateID, {
            id : playerId,
            website : website,
            promocode : promocode
        }, {
            headers : {
                "Authorization" : "Bearer "+localStorage.getItem("raff-token")
            }
        })
        setMLoading(false);

        if(response.data.Error == null) {
            toast.success("Player moved successfully.", {
                duration: 4000
            });
            GetPlayers(1);
        } else {
            toast.error(response.data.Error, {
                duration: 4000
            });
        }
    }
    
    const GetAllData = async () => {
        const response = await axios.get(window.__CFG.API + "affiliates/ListAffiliateWebsites/" + AffiliateID, {
            headers : {
                "Authorization" : "Bearer "+localStorage.getItem("raff-token")
            }
        })
        const uresponse = await axios.get(window.__CFG.API + "affiliates/ListAllAffiliatePromocodes/" + AffiliateID, {
            headers : {
                "Authorization" : "Bearer "+localStorage.getItem("raff-token")
            }
        })

        if(response.data.Error == null) {
            setWebsites(response.data.Result)
        }
        if(response.data.Error == null) {
            setPromocodes(uresponse.data.Result);
        }
    }

    useEffect(() => {
        GetAllData();
    }, [])

    return (
        <>
            <div className="aff-grp-wrp">
                <div className='aff-grp-section-wp'>
                    <div className='aff-grp-section'>
                        <div className='aff-grp-section-title'>
                            Affiliate Players
                        </div>

                        <div className="promo-form-wp">
                            <div className="promo-form">
                                <div className="promo-lbl">
                                    Site
                                </div>
                                <div className="promo-in">
                                    <select onChange={e => setWebsite(e.target.value)} style={{ padding: 5, width: "100%" }} >
                                        <option value="">Website</option>
                                        {
                                            websites.map(site => {
                                                return (
                                                    <option value={site.value}>{site.label}</option>
                                                )
                                            })
                                        }
                                    </select>
                                </div>
                            </div>
                            <div className="promo-form">
                                <div className="promo-lbl">
                                    Promocode
                                </div>
                                <div className="promo-in">
                                    <select onChange={e => setPromocode(e.target.value)} style={{ padding: 5, width: "100%" }} >
                                        <option value="">Promocode</option>
                                        {
                                            promocodes.map(code => {
                                                return (
                                                    <option value={code.value}>{code.label}</option>
                                                )
                                            })
                                        }
                                    </select>
                                </div>
                            </div>
                            <div className="promo-form">
                                <div className="promo-lbl">
                                    Player
                                </div>
                                <div className="promo-in">
                                    <input style={{ padding: 5, width: "100%" }} placeholder="Player ID" value={playerId} onChange={e => setPlayerId(e.target.value)} />
                                </div>
                            </div>
                            <div className="promo-form">
                                <div className="promo-lbl">
                                </div>
                                <div className="promo-in">
                                    <Button onClick={MovePlayer} disabled={mloading} className="w-100 bg-warning border-0 rounded-0 btn-height text-black btn-com-grp "
                                    >
                                        {
                                            mloading ? (
                                                <>
                                                    <Spinner size="sm" />
                                                </>
                                            ) : (
                                                <>Move Player</>
                                            )
                                        }
                                    </Button>
                                </div>
                            </div>
                        </div>


                        <div className='aff-grp-section-table'>
                            <div className="aff-dash-summary-table">
                                <TableComponent loading={loading} columns={columns} data={data} onPageChange={page => setPage(page)} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}